<template>
  <div>
    <vsmallheader></vsmallheader>
    <div>
      <div class="metter">
        <!-- {{dongtai}} -->
        <div style="font-size:16px;padding-bottom:10px">
          <span style="cursor: pointer;" @click="retrun">首页</span>/列表
        </div>
        <div class="mettera">
          <div>
            <div class="cate">
              <div class="cate_police">
                <div class="cate-all">
                  <span style="margin-left: 22px;">时间：</span>
                </div>
                <div class="subject">
                  <span
                    v-for="(item, index) in TImedata"
                    :key="index"
                    :class="{heightlight : timeindex==index}"
                    @click="timeArea(index,item)"
                  >{{ item.name }}</span>
                </div>
              </div>

              <div class="cate_police">
                <div class="cate-all">
                  <span>地市/州：</span>
                </div>
                <div :class='["subject", cityers&&cityputaway ? "hiddenlist" : ""]' ref="getheight">
                  <span
                    v-for="(item, index) in cityList"
                    :key="index"
                    :class="{heightlight : cityIndex==index}"
                    @click="selectCity(index,item)"
                  >{{ item.name }}</span>
                  <div v-if="cityers&&cityputaway" class="showlist" @click="()=>{cityputaway = !cityputaway}">
                    <span>更多</span>
                    <i class="el-icon-caret-bottom"></i>
                  </div>
                  <div v-if="cityers&&!cityputaway" class="showlist" @click="()=>{cityputaway = !cityputaway}">
                    <span>收起</span>
                    <i class="el-icon-caret-top"></i>
                  </div>
                </div>
              </div>

              <div
                class="cate_police"
                style="border-top: 1px solid #dcdfe6;margin-right: 32px;margin-left: 160px;padding-top: 10px; "
              >
                <div class="subject" style="padding-right: 30px;">
                  <span
                    v-for="(item, index) in newList"
                    :key="index"
                    :class="{heightlight : newIndex==item.CateId}"
                    @click="policeNew(index,item)"
                  >{{item.name}}</span>
                </div>
                <el-input
                  @keyup.enter.native="getnewsList"
                  size="large"
                  placeholder="请输入搜索内容"
                  v-model="listQuerys.Title"
                  class="input-with-select"
                  style="width:300px; color: white;height: 40px;border-top-left-radius: 5px;border-bottom-left-radius: 5px;"
                >
                  <el-button
                    @click="getnewsList"
                    slot="append"
                    icon="el-icon-search"
                    style="background: #545c63;border-top-left-radius: 0px;border-bottom-left-radius: 0px;height: 40px;color: white; font-size: 16px;"
                  ></el-button>
                </el-input>
              </div>
            </div>
          </div>

          <ul style="height:535px">
            <li v-for="(item,index) in newsss" :key="index" @click="newsgetone(item.id,item)">
              <div>
                <div></div>
                <div
                  style="width:560px;overflow: hidden;text-overflow: ellipsis; white-space: nowrap;"
                  v-html="item.title"
                ></div>
                <div
                  style="padding:0 5px;width:100px;overflow: hidden;text-overflow: ellipsis; white-space: nowrap;"
                >{{item.cateName}}</div>
                <div
                  style="width:280px;text-align: center;overflow: hidden;text-overflow: ellipsis; white-space: nowrap;"
                >{{item.deptName}}</div>
              </div>
              <div style="margin-right:2px;width:52px;    text-align: right;">({{item.readCount}})</div>
              <div style="width:92px;">{{item.publishTime.substring(0, 10)}}</div>
            </li>
          </ul>
          <div class="pageblock">
            <el-pagination
              background
              prev-text="上一页"
              next-text="下一页"
              layout="total,prev, pager, next,jumper"
              :page-size="listQuerys.Limit"
              :current-page.sync="listQuerys.Page"
              :total="dataCount"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- <linecom></linecom> -->
  </div>
</template>
<script>
import { getCity } from '@/api/public.js';
import * as news from '@/api/clientshome/index.js';
import vsmallheader from '@/views/smallHeader/index';
import * as resourceInfo from '@/api/resources/index.js';
import linecom from '@/components/linecom/index';
import * as homes from '@/api/clientshome/index.js';
export default {
  components: {
    vsmallheader,
    linecom,
  },
  data() {
    return {
      TImedata: [{ name: '全部', id: 0 }],
      timeindex: 0,
      cityList: [{ name: '全部', id: 0 }],
      cityIndex: 0,
      newList: [{ CateId: null, name: '全部' }],
      newIndex: 0,
      dongtai: '',
      newsss: '',
      listQuerys: {
        // 查询条件
        Page: 1,
        Limit: 13,
        Key: null,
        Title: null,
        Year: null,
        CateId: null,
        PassSate: 1, //审核通过的显示在前端页面
        RegionId: 0, //地市id
      },
      listQuery: {
        // 查询字典条件
        page: 1,
        limit: 30,
        key: null,
        namespaceId: null,
      },
      dataCount: 0,
      cityers: false,
      cityputaway: true,
    };
  },
  created() {
    this.listQuerys.CateId = this.$route.query.CateId;
    if (this.$route.query.CateId) {
      this.newIndex = this.$route.query.CateId;
    }
    this.getPmiDictionary(62, this.newList);
    this.getDishi();
    this.getnewsList();
    this.getTime();
    // if(this.$route.query.CateId==1){
    //     this.dongtai='通知公告'
    //     this.newIndex=2
    // }else if(this.$route.query.CateId==0){
    //     this.dongtai='新闻动态'
    //     this.newIndex=1
    // }else{
    //     this.dongtai='培训动态'
    //     this.newIndex=3
    // }
  },
  methods: {
    getTime() {
      let year = new Date().getFullYear();
      for (var i = 0; i <= 4; i++) {
        this.TImedata.push({ name: year, id: i + 1 });
        year--;
      }
    },
    //查询新热
    policeNew(index, item) {
      this.newIndex = item.CateId;
      this.listQuerys.CateId = item.CateId;
      this.getnewsList();
    },
    timeArea(index, item) {
      this.timeindex = index;
      if (index == 0) {
        this.listQuerys.Year = 0;
      } else {
        this.listQuerys.Year = item.name;
      }
      this.getnewsList();
    },
    //获取字典数据  index代表namespaceId，arr代表传出的数组
    getPmiDictionary(index, arr) {
      this.listQuery.namespaceId = index;
      homes
        .GetSecondList(this.listQuery)
        .then((response) => {
          // console.log(response);
          response.result.forEach((e) => {
            arr.push({ name: e.name, CateId: e.id });
          });
          // console.log(response.data.name)
        })
        .catch(() => {
          // debugger
        });
    },
    getnewsList() {
      news.loadnews(this.listQuerys).then((res) => {
        this.dataCount = res.count;
        this.changeColor(res.data);
      });
    },
    changeColor(resultsList) {
      // resultsList全部数据，改变title里的高亮颜色，用正则先去匹配全局匹配到，然后用字符串的替换将原来的title替换需要高亮的部分
      resultsList.map((item, index) => {
        // console.log('item', item)
        if (this.listQuerys.Title && this.listQuerys.Title.length > 0) {
          // 匹配关键字正则
          let replaceReg = new RegExp(this.listQuerys.Title, 'gi');
          // 高亮替换v-html值
          let replaceString =
            '<span class="search-text" style="color:red;">' +
            this.listQuerys.Title +
            '</span>';
          resultsList[index].title = item.title.replace(
            replaceReg,
            replaceString
          );
        }
      });
      // this.results = []
      // this.results = resultsList
      this.newsss = [];
      this.newsss = resultsList;
      console.log(this.newsss);
    },
    handleSizeChange(val) {
      this.listQuerys.Limit = val;
      this.getnewsList();
    },
    handleCurrentChange(val) {
      this.listQuerys.Page = val;
      this.getnewsList();
    },
    //查询地市
    selectCity(index, item) {
      this.cityIndex = index;
      this.listQuerys.RegionId = item.id;
      this.getnewsList();
    },
    //获取地市
    getDishi() {
      getCity().then((res) => {
        res.result.forEach((e) => {
          this.cityList.push({ name: e.name, id: e.id });
        });
        this.$nextTick(()=>{
          if(this.$refs.getheight.clientHeight > 42){
            this.cityers = true
          }
        })
      });
    },
    newsgetone(index, item) {
      let a = {
        id: index,
      };
      console.log(item);
      news.CmsArticleReadCount(a).then((res) => {});
      this.$router.push({
        path: '/home/newsgetone',
        query: {
          id: index,
          cateName: item.cateName,
        },
      });
    },
    retrun() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
/* 高亮 */
.heightlight {
  background-color: #3c95d6 !important;
  color: #f8fafc !important;
}
.metter {
  width: 1200px;
  min-height: 750px;
  /* background-color:; */
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 20px;
}
.mettera {
  padding-top: 20px;
  width: 1200px;
  min-height: 750px;

  /* height: 700px; */
  /* background-color:; */
  margin: 0 auto;
  box-shadow: 2px 2px 5px rgba(215, 215, 215, 0.968627450980392);
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(242, 242, 242, 1);
  border-radius: 5px;
}

li {
  cursor: pointer;
  height: 30px;
  line-height: 30px;
  margin-left: 20px;
  list-style-type: disc;
  display: flex;
  justify-content: space-between;
  margin-right: 30px;
  font-size: 16px;
  margin-top: 8px;
}
li > div:nth-child(1) {
  display: flex;
}
li > div:nth-child(1) > div:nth-child(1) {
  border-radius: 50%;
  height: 10px;
  width: 10px;
  background-color: #333;
  margin-top: 9px;
  margin-right: 20px;
}
li > div:nth-child(1) > div:nth-child(2) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
li:hover {
  color: rgb(87, 179, 255);
}
li:hover > div:nth-child(1) > div:nth-child(1) {
  border-radius: 50%;
  height: 10px;
  width: 10px;
  background-color: rgb(87, 179, 255);
}
.pageblock {
  padding-bottom: 20px;
  margin-top: 20px;
  text-align: center;
}

.cate {
  width: 1180px;
  margin: 0 auto;
  padding: 0px 10px;
}
.cate_police {
  display: flex;
  font-size: 16px;
  margin-left: 32px;
  padding: 5px 0;
}
.cate-all {
  width: 140px;
  font-weight: 700;
}
.subject {
  position: relative;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
  padding-right: 80px;
  display: flex;
  flex-wrap: wrap;
}
.subject > span {
  cursor: pointer;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  color: #333333;
  margin-right: 10px;
  /* background: #ECECEC; */
  opacity: 1;
  border-radius: 6px;
  margin-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
  border: 1px solid white;
  border-radius: 5px;
}
.subject > span:hover {
  border: 1px solid #3c95d6;
  color: #3c95d6;
  border-radius: 5px;
}

.subject >.showlist{
  position:absolute;
  z-index: 3;
  right: 30px;
  top: 0px;
  padding-left: 10px;
  cursor: pointer;
  height: 22px;
  line-height: 22px;
  font-size: 14px;
  color: #4D515A;
}
.hiddenlist{
  height: 42px;
}
</style>